// Bot Detection and Conditional Analytics Loading
// Prevents Amplitude from loading for detected bots to reduce monthly tracked users
(function () {
  'use strict';

  // Debug: Check what was set by theme.liquid
  console.log('[BlankaAnalytics] Initial state from theme.liquid:', window.BlankaAnalytics);

  // Bot detection configuration and analytics loading
  // Preserve existing properties set by theme.liquid (like amplitudeHelpersUrl)
  window.BlankaAnalytics = window.BlankaAnalytics || {};
  window.BlankaAnalytics.isBot = window.BlankaAnalytics.isBot || null;
  window.BlankaAnalytics.amplitudeLoaded = window.BlankaAnalytics.amplitudeLoaded || false;

  // Simple fallback bot detection methods
  window.BlankaAnalytics.fallbackBotDetection = window.BlankaAnalytics.fallbackBotDetection || function() {
      var ua = navigator.userAgent.toLowerCase();
      var botPatterns = [
        'bot', 'crawler', 'spider', 'scraper', 'headless',
        'phantom', 'selenium', 'puppeteer', 'playwright',
        'lighthouse', 'gtmetrix', 'pagespeed', 'screaming frog'
      ];

      // Check user agent
      for (var i = 0; i < botPatterns.length; i++) {
        if (ua.indexOf(botPatterns[i]) !== -1) return true;
      }

      // Check for headless Chrome indicators
      if (window.navigator.webdriver) return true;
      if (window.outerHeight === 0 && window.outerWidth === 0) return true;
      if (!window.navigator.languages || window.navigator.languages.length === 0) return true;

      // Check for missing browser APIs common in real browsers
      if (!window.chrome && !window.safari && !window.opera) {
        // Could be Firefox or other browser, check more carefully
        if (!window.InstallTrigger && !window.sidebar) return true;
      }

      return false;
    };

  window.BlankaAnalytics.loadAnalytics = window.BlankaAnalytics.loadAnalytics || function() {
      if (window.BlankaAnalytics.amplitudeLoaded || window.BlankaAnalytics.isBot) return;

      // Load Amplitude SDK
      var script1 = document.createElement('script');
      script1.async = true;
      script1.src = 'https://cdn.amplitude.com/libs/analytics-browser-2.17.6-min.js.gz';
      script1.crossOrigin = 'anonymous';
      document.head.appendChild(script1);

      // Load GA forwarder plugin
      var script2 = document.createElement('script');
      script2.async = true;
      script2.src = 'https://cdn.amplitude.com/libs/plugin-ga-events-forwarder-browser-0.4.2-min.js.gz';
      script2.crossOrigin = 'anonymous';
      document.head.appendChild(script2);

      // Load Amplitude experiment SDK
      var script3 = document.createElement('script');
      script3.type = 'text/javascript';
      script3.src = 'https://cdn.amplitude.com/script/ea6e92cde00365dd4d9aae3b4761065a.experiment.js';
      document.head.appendChild(script3);

      // Load Amplitude helpers with proper URL handling
      var script4 = document.createElement('script');
      var helpersUrl = window.BlankaAnalytics && window.BlankaAnalytics.amplitudeHelpersUrl;

      console.log('[BlankaAnalytics] Loading amplitude helpers from URL:', helpersUrl);

      if (!helpersUrl) {
        // Try to construct the URL based on current page location
        var currentScript = document.querySelector('script[src*="bot-detection.js"]');
        if (currentScript && currentScript.src) {
          helpersUrl = currentScript.src.replace('bot-detection.js', 'amplitude-helpers.js');
          console.log('[BlankaAnalytics] Constructed URL from script tag:', helpersUrl);
        } else {
          // Last resort fallback - this might not work on Shopify but better than nothing
          console.warn('[BlankaAnalytics] Could not determine amplitude-helpers.js URL, using fallback');
          helpersUrl = window.location.origin + '/assets/amplitude-helpers.js';
        }
      }

      script4.src = helpersUrl;
      script4.defer = true;
      script4.onload = function() {
        console.log('[BlankaAnalytics] amplitude-helpers.js loaded successfully');
      };
      script4.onerror = function() {
        console.error('[BlankaAnalytics] Failed to load amplitude-helpers.js from:', helpersUrl);
        console.log('[BlankaAnalytics] Analytics initialization will continue without helpers');
      };
      document.head.appendChild(script4);

      window.BlankaAnalytics.amplitudeLoaded = true;
      console.log('[BlankaAnalytics] Analytics loaded for human user');
    };

  // Initialize bot detection using reliable fallback method
  // Note: BotD v2 requires ES modules which are incompatible with traditional script loading
  // Our fallback detection is comprehensive and reliable for production use
  function initBotDetection() {
    console.log('[BlankaAnalytics] Initializing bot detection with fallback method');
    console.log('[BlankaAnalytics] Available amplitude helpers URL:', window.BlankaAnalytics.amplitudeHelpersUrl);

    window.BlankaAnalytics.isBot = window.BlankaAnalytics.fallbackBotDetection();

    if (!window.BlankaAnalytics.isBot) {
      console.log('[BlankaAnalytics] Human user detected - loading analytics');
      window.BlankaAnalytics.loadAnalytics();
    } else {
      console.log('[BlankaAnalytics] Bot detected - analytics blocked');
    }
  }

  // Initialize bot detection immediately
  initBotDetection();

})();